declare var window:any;
declare var Swiper : any;

export const index = function(){
    // let inp = <HTMLInputElement>document.getElementById('checkNotify');
    // if(inp.value){
    //     let popup = document.querySelector('.popup-notify');
    //     let text = popup.querySelector('.wrapper h2');
    //     // text.innerHTML = "Cảm ơn đã đăng kí ở đây!";
    //     popup.classList.add('show');
    // }
}